import { connect } from 'react-redux';
import { useEffect, useState } from 'react';
import axios from 'axios';
import { useHistory, Link } from 'react-router-dom';

import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

import { getOnboardingData, saveOnboardingStep } from '../../utils/onboardingUtils';
import AuthContainer from '../shared/AuthContainer';

const OnboardingAuthMobile = ({auth}) => {        
    const step_number = 3;
    const history = useHistory();
    const [email, setEmail] = useState('');
    const [status, setStatus] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);

    useEffect(() => {                
        // If user is already authenticated, skip step 3 and go to step 4
        if (auth?.user?.id) {
            window.location.href = '/onboarding/plan';
            return;
        }
        
        const setOnboardingStep = async () => {                   
            try {
                // Save to localStorage
                saveOnboardingStep('auth', { step: step_number, timestamp: Date.now() });
            } catch (error) {
                console.error('Error setting onboarding step:', error);
                // Still save to localStorage even if API call fails
                saveOnboardingStep('auth', { step: step_number, timestamp: Date.now() });
            }
        }

        setOnboardingStep();
    }, [auth]);

    const handleGoogleAuth = async () => {
        try {
            // Get onboarding data
            const onboardingData = getOnboardingData();
            
            if (onboardingData) {
                // Send onboarding data to backend before OAuth redirect
                await axios.post('/auth/google/init', {
                    onboardingData: onboardingData
                });
            }
            
            // Redirect to Google OAuth (no state parameter needed)
            window.location.href = '/auth/google';
        } catch (error) {
            console.error('Error preparing Google OAuth:', error);
            // Still redirect to Google OAuth even if data preparation fails
            window.location.href = '/auth/google';
        }
    };

    const handleMagicLinkSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);
        
        try {
            const formData = new URLSearchParams();
            formData.append('email', email);
            
            const onboardingData = getOnboardingData();
            if (onboardingData) {
                formData.append('onboardingData', JSON.stringify(onboardingData));
            }
        
            const res = await axios.post('/auth/magic?type=signup', formData.toString(), {
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                withCredentials: true
            });
            
            if (res.data.waitlisted) {
                setStatus('This email is on our waitlist. Please contact support for access.');
            } else if (res.data.sent) {
                // Redirect to check email page with context that this is from onboarding
                history.push('/check-your-email?onboarding=true');
            } else {
                setStatus('Something unexpected happened.');
            }
        } catch (err) {
            console.error('Error sending magic link:', err);
            setStatus('Something went wrong. Please try again.');
        } finally {
            setIsSubmitting(false);
        }
    };

    const getProgressPercentage = () => {
        // Auth is step 4, so (4-1)/5 = 60%
        return 60;
    };

    return (
        <div className="pt-5 onboarding-section">    
            <Row className="onboarding-header">
                <Col xs={1} md={2}></Col>
                <Col xs={10} md={8}>       
                        
                    <Row className="text-center onboarding-title-row">
                        <Col className="onboarding-title">Sign Up</Col>
                    </Row>
                    
                                            {/* Progress Bar */}
                        <Row className="mt-4">
                            <Col>
                                <div className="text-center mb-1">
                                    <span className="onboarding-progress-percentage">
                                        {Math.round(getProgressPercentage())}% Complete
                                    </span>
                                </div>
                                <div className="onboarding-progress">
                                    <div 
                                        className="onboarding-progress-bar"
                                        style={{ width: `${getProgressPercentage()}%` }}
                                    ></div>
                                </div>
                            </Col>
                        </Row>
                    
                    {/* Use the shared auth components for consistency */}
                    <Row className="mt-4">
                        <Col>
                            <div className="onboarding-auth-container">
                                                                         <AuthContainer
                                             email={email}
                                             setEmail={setEmail}
                                             onGoogleAuth={handleGoogleAuth}
                                             onMagicLinkSubmit={handleMagicLinkSubmit}
                                             googleButtonText="Sign up with Google"
                                             magicLinkButtonText="Sign up with email"
                                             disabled={isSubmitting}
                                             />
                                
                                {/* Legal Agreement */}
                                <div className="text-center mt-4 mb-2">
                                    <p className="small mb-0" style={{ color: '#94a3b8' }}>
                                        By signing up, you agree to our{' '}
                                        <Link to="/terms" className="text-decoration-underline" style={{ color: '#94a3b8' }}>Terms</Link>
                                        {' '}and{' '}
                                        <Link to="/privacy" className="text-decoration-underline" style={{ color: '#94a3b8' }}>Privacy Policy</Link>.
                                    </p>
                                </div>
                                
                                {status && <p className="mt-3 text-center text-danger">{status}</p>}
                            </div>
                        </Col>
                    </Row>
                </Col>                            
            </Row>
        </div>
    );
};

function mapStateToProps({auth}) {
    return { auth };
}

export default connect(mapStateToProps)(OnboardingAuthMobile);
